import { render } from "./RejectedPaymentLiquidations.vue?vue&type=template&id=737015ec"
import script from "./RejectedPaymentLiquidations.vue?vue&type=script&lang=js"
export * from "./RejectedPaymentLiquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__